import styled from 'styled-components';
import {Button, Collapse} from 'antd';
import {typographyStyles} from '../../../../utils/styles';
import Empty from '../../../Empty';

const StyledExpenses = styled(Collapse)`
  width: 100%;

  .ant-table-wrapper {
    table {
      width: 100%;
      border-radius: 4px;
    }

    .ant-table-thead > tr > th,
    .ant-table-thead > tr > td {
      background-color: ${props => props.theme.colors.additional_bg_2};
      &:before {
        content: none !important;
      }
    }
  }
  .ant-collapse-content-box {
    & > .ant-space {
      width: 100%;
    }
  }
  .ant-collapse-item {
    .ant-collapse-header {
      padding: 12px 0;
    }
    .ant-collapse-content-box {
      padding: 0 0 16px 0;
      display: flex;
      & > .ant-space {
        width: 100%;
      }
    }
  }
  .ant-collapse-header-text {
    ${typographyStyles.body.medium};
    color: ${props => props.theme.colors.neutral_10};

    .ant-space-item {
      display: flex;
    }

    svg {
      height: 20px;
      width: 20px;
      path {
        fill: ${props => props.theme.colors.neutral_7};
      }
    }
  }
`;

const StyledExpensesMoreButton = styled(Button)`
  width: max-content;

  &.ant-btn-variant-link {
    ${typographyStyles.footnote.description};
    color: ${props => props.theme.colors.primary_6};
    padding: 0;
  }
`;

const StyledExpensesContainer = styled.div`
  min-height: 100px;
  width: 100%;
  .expense-details-panel {
    width: calc(100% - 24px);

    .ant-tabs-content-holder {
      padding: 0;
    }

    .ant-tabs-content {
      padding: 16px 24px 0 24px;
      max-height: calc(100vh - 66px - 24px * 2 - 42px);
      overflow: auto;
    }

    .expense-details-tab {
      margin-bottom: 24px;

      &.with-footer {
        margin-bottom: calc(82px + 16px);
      }
    }

    & > .ant-tabs {
      .ant-tabs-nav {
        padding-inline-end: 8px;
      }
    }
  }
`;

const StyledExpensesEmpty = styled(Empty)`
  background-color: ${props => props.theme.colors.neutral_1};
  border: 1px solid ${props => props.theme.colors.neutral_4};
  border-radius: 4px;
  margin: 24px 0 0 0;
  padding: 40px 24px;
  width: 100%;

  .ant-empty-image {
    height: unset;
    svg {
      height: auto;
    }
  }

  .ant-empty-description {
    h3 {
      ${typographyStyles.heading.h5};
      color: ${props => props.theme.colors.neutral_10};
    }
    p {
      color: #8C8C8C;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 0;
    }
  }
`;

export {
  StyledExpenses,
  StyledExpensesMoreButton,
  StyledExpensesContainer,
  StyledExpensesEmpty
}
